<app-loading *ngIf="loading"></app-loading>
<!-- <div class="counter-down" *ngIf="true">
  <div class="background">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 col-xl-8 col-md-6">
          <p class="bidding-ends">Bidding ends in</p>
          <app-auction-end-count-down (TimerEnded)="OnTimerEnded($event)" *ngIf="  lastSeconds!: number
          " [TotalTime]="10"
            [RemainingTime]="10"></app-auction-end-count-down>
        </div>
        <div class="col-lg-6 col-xl-4 col-md-6"></div>

      </div>
    </div>

  </div>
</div> -->
<!-- {{test_timer}}
<timer [class.timeExtended]="timeExtended" *ngIf="auctionData?.end_at"
  [Mode]="'light'" type="date" [time]="test_timer" [startORend]="2"
  (LessThan10Second)="LessThan10Second.emit($event);lastSeconds=$event"><span *ngIf="timeExtended"
    id="timeExtended">Time Extended</span></timer>
<button mat-button (click)="chengeValue()">Cange value</button>
 -->

<div *ngIf="!loading">
  <div class="row">
    <app-breadcrumb *ngIf="!isbidder" [lablPage]="'Auction Item.Item Detailes'|translate" [breadcrumbItemsList]="[{title:'items-requests.Dashboard',url:'/admin'},{title:'Home.Auctions',url:'/rooms'},
      {title:'Auction Item.Auction Detailes',url:'/rooms/detailes/'+auctionData?.room?.id},
      {title:'Auction Item.Item Detailes',url:'/rooms/auction/'+auctionData?.id}]"></app-breadcrumb>

    <div class="auction-breadcrumb mb-4" *ngIf="isbidder" aria-label="breadcrumb">
      <div class="container-fluid top-breadcrumb">
        <div class="d-flex justify-content-between">
          <div class="auction-breadcrumb-active">
            {{auctionData?.name}}
          </div>
          <!-- <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#">{{"Home.Home"|translate}}</a></li>
            <li class="breadcrumb-item"><a
                (click)="_config.goTo('/MainAuction/'+auctionData?.room?.id)">{{'bidders.Auction Details'
                | translate}}</a></li>
            <li class="breadcrumb-item active" aria-current="page"> {{auctionData?.name}}</li>
          </ol> -->
          <app-breadcrumb class="auction_breadcrumb"
            [breadcrumbItemsList]="[{title:'Home.Home',url:'/'},{title:'bidders.Auction Details',url:'/MainAuction/'+auctionData?.room?.id},{title:auctionData?.name,url:'/auction/'+auctionData?.id}]"></app-breadcrumb>

        </div>
      </div>
    </div>

    <div [ngClass]="(auctionData?.is_joined && auctionStatus == 'ongoing') ||
    (!auctionData?.is_joined && auctionStatus == 'upcoming') ||
    (auctionData?.is_joined && auctionStatus == 'upcoming') ||
    (!auctionData?.is_joined && auctionStatus == 'ongoing') ||
    (auctionData?.is_joined && auctionStatus == 'ongoing') ||
    (auctionData?.is_joined && auctionStatus == 'end') ||
     (admin || auctionData?.is_owner || auctioneer || master) ? 'col-md-8 col-12' : 'col-12'">
      <app-item-info [auctionData]="auctionData" [auctionStatus]="auctionStatus"></app-item-info>
    </div>
    <ng-container *ngIf="
    (auctionData?.is_joined && auctionStatus == 'ongoing') ||
    (!auctionData?.is_joined && auctionStatus == 'upcoming') ||
    (auctionData?.is_joined && auctionStatus == 'upcoming') ||
    (!auctionData?.is_joined && auctionStatus == 'ongoing') ||
    (auctionData?.is_joined && auctionStatus == 'ongoing') ||
    (auctionData?.is_joined && auctionStatus == 'end') ||
      (admin || auctionData?.is_owner || auctioneer || master)">
      <div class="col-md-4 col-12" [ngStyle]="lastSeconds ? { 'z-index':'4' } : { 'z-index': 'initial' }">



        <div *ngIf="!admin && !auctioneer && !master &&!auctionData?.is_owner" class="auction-actions bg-light">
          <span [ngSwitch]="auctionStatus" *ngIf="!auctionData?.is_closed">
            <p *ngSwitchCase="'upcoming'">
              <timer [Mode]="'light'" type="date" (TimerEnded)="$event?OnReload('upcoming'):null"
                [time]="auctionData?.remaining_time" [startORend]="1"></timer>

            </p>
            <div *ngSwitchCase="'ongoing'">

              <timer [class.timeExtended]="timeExtended" *ngIf="auctionData?.end_at"
                (TimerEnded)="$event?OnReload('ongoing',true):null" [Mode]="'light'" type="date"
                [time]="auctionData?.remaining_time" [auctionData]="auctionData" [startORend]="2" [getRemainingFromSocket]="1"
                (RemainingTime)="getRemaining();"><span *ngIf="timeExtended" id="timeExtended">Time Extended</span>
              </timer>


              <div *ngIf="!auctionData?.end_at  && auctionData?.is_joined && bidders.length"
                class="text-center   w-100 mt-3"
                style="background-color:#f5f4f8;margin-bottom: 20px;padding-bottom: 20px;">
                <!-- <div class="d-flex justify-content-around align-items-center w-100 mt-3" *ngIf="!auctionData?.end_at && bidders.length"> -->

                <!-- <app-auction-end-count-down style="width: 5rem; height: 5rem;" [countDown]="secondsDown" [currentPercent]="currentPercent"></app-auction-end-count-down> -->
                <div class="w-100" style="max-width: 150px;max-height:150px; margin: auto;background-color:#f5f4f8">
                  <circle-progress [percent]="percent" [title]="timeLeft" [showSubtitle]="false" [subtitle]="'ddd'"
                    [innerStrokeWidth]="0" outerStrokeColor="#FF6B6B" innerStrokeColor="#C7E596" [animationDuration]='0'
                    backgroundStroke='#FFE4E4' [backgroundStrokeWidth]="5" [backgroundPadding]="0" [responsive]="true"
                    [showUnits]='false' titleFontSize='30' titleFontWeight='700' titleColor="#F53649"
                    subtitleFontSize="20" subtitleFontSize="0" subtitleFontWeight='0'></circle-progress>
                </div>

                <div class="w-100">End in {{timeLeft}} seconds </div>
              </div>
            </div>

          </span>

          <div *ngIf="auctionData?.is_joined && auctionStatus == 'ongoing'&&!auctionData?.is_closed"
            class="joined-auction">


            <div class="wallet-current">

              <div class="current-bid">
                <p class="current-bid-txt">{{auctionData?.is_closed?("Auction Item.Final Bid"|translate):("Auction Item.Current bid"|translate)}}
                </p>
                <p class="current-bid-price"><span>{{"Auction Item.SR"|translate}}</span>
                  {{auctionData?.is_closed?auctionData?.last_bidding :number | kFormat}}
                </p>

                <p class="current-bid-txt current-bid-last">{{"Auction Item.Your last bid"|translate}}</p>

                <ng-container *ngIf="lastbid; else elseTemplate">
                  <p class="current-bid-last-price"><span>{{"Auction Item.SR"|translate}}</span> {{lastbid | kFormat}}
                  </p>
                </ng-container>
                <ng-template #elseTemplate>
                  <p class="current-bid-last-price">{{"Auction Item.You have not bid yet"|translate}}</p>
                </ng-template>



              </div>


              <div class="current-wallet">
                <img src="assets/images/icons/wallet.svg" alt="" srcset="">
                <p class="current-wallet-txt">{{"Auction Item.Current wallet balance"|translate}}</p>
                <p class="current-wallet-price"><span>{{"Auction Item.SR"|translate}}</span> {{current_balance|kFormat}}
                </p>
              </div>

            </div>
            <div class="auction-end"*ngIf="winnerUserAuction ==  this.userInfo.user.id && !auctionData?.is_closed && auctionData?.reserve_price > lastbid && showIncreasePrice">
              <div class="bidder">
                <app-reserve-price
                  
                  (reloadPage)="reloadPage($event)" [myBlanace]="current_balance" [auctionData]="auctionData"
                  [number]="lastbid" [startDateTimer]="startDateTimer"
                  [endDateTimer]="endDateTimer"></app-reserve-price>
              </div>
            </div>
            <div class="bid-amounts">
              <p class="bid-amounts-txt" *ngIf="btns?.length">
                {{"Auction Item.Instantly bid amounts"|translate}}</p>
              <div class="bid-amounts-btns" *ngIf="btns?.length">
                <button *ngFor="let btn of btns" (click)="onAddPrice(btn.price)" class="btn price">
                  {{"Auction Item.SR"|translate}}
                  {{btn.price}}</button>


              </div>


              <div class="bid-amounts-manually">
                <p class="manually-txt">{{'items-requests.Or add manually' | translate}}</p>
                <div class="manually-control Web_controlls"> 
                  <div [class.disable]="CustomPrice<=0" class="minus"
                    [matTooltip]="('Auction Item.Minus'|translate)+' '+auctionData?.manual_bidding"
                    (click)="onAddCustomPrice('minus',auctionData?.manual_bidding)">
                    <img src="assets/images/icons/minus.svg">
                  </div>
                  <div class="total">
                    <!-- <span>SR</span> {{CustomPrice}} -->
                    <input type="text" appOnlynumber [(ngModel)]="CustomPrice" maxlength="9">
                  </div>
                  <div class="plus" (click)="onAddCustomPrice('plus',auctionData?.manual_bidding)"
                    [matTooltip]="('Auction Item.Plus'|translate)+' '+auctionData?.manual_bidding">
                    <img src="assets/images/icons/plus.svg">
                  </div>
                </div>
                <div class="manually-control Mobile_controlls"> 
                  <div class="d-flex align-items-center justify-content-evenly mb-2">
                      <div [class.disable]="CustomPrice<=0" class="minus"
                      [matTooltip]="('Auction Item.Minus'|translate)+' '+auctionData?.manual_bidding"
                      (click)="onAddCustomPrice('minus',auctionData?.manual_bidding)">
                      <img src="assets/images/icons/minus.svg">
                    </div>
                    <div class="plus" (click)="onAddCustomPrice('plus',auctionData?.manual_bidding)"
                      [matTooltip]="('Auction Item.Plus'|translate)+' '+auctionData?.manual_bidding">
                      <img src="assets/images/icons/plus.svg">
                    </div>
                  </div>
                  
                  <div class="total">
                    <!-- <span>SR</span> {{CustomPrice}} -->
                    <input type="text" class="w-100" appOnlynumber [(ngModel)]="CustomPrice" maxlength="9">
                  </div>
                 
                </div>
                <div class="manually-action">
                  <button (click)="onSendCustomPrice()" class="btn"> {{'items-requests.Submit Bid' |translate}}</button>
                </div>
              </div>

            </div>



          </div>


          <!-- join and withdraw auction  -->
          <div class="join mb-4" *ngIf="!auctionData.is_closed && !auctionData?.is_owner">

            <!-- join auction  -->
            <ng-container *ngIf="!auctionData?.is_joined">
              <div *ngIf="!admin" class="join-txt">
                <p>{{"Auction Item.To join this auction you need to have the below amount in your wallet"|translate}}
                </p>
              </div>

              <div *ngIf="auctionStatus != 'end'" class="start-bid-amount">
                <p class="start-txt">{{"Auction Item.Starting bid"|translate}}</p>
                <p class="start-amount"><span>{{"Auction Item.SR"|translate}}</span>{{auctionData?.minimum_price |
                  number }}</p>
              </div>

              <div *ngIf="!admin" class="join-btn">

                <button (click)="onJoinAuction()" mat-button class="btn join">
                  {{"Auction Item.join auction"|translate}}</button>
                <div class="note-join">
                  {{"Auction Item.Note that once you join this auction this amount will be deducted temporarily from your wallet"|translate}}
                </div>
              </div>
            </ng-container>
            <!-- end join auction  -->

            <!-- withdraw auction  -->
            <ng-container *ngIf="auctionData?.is_joined && auctionStatus == 'upcoming' && !admin">
              <div class="join-btn">
                <div class="start-bid-amount">
                  <p class="start-txt">{{"Auction Item.Starting bid"|translate}}</p>
                  <p class="start-amount"><span>{{"Auction Item.SR"|translate}}</span>{{auctionData?.minimum_price |
                    number}}</p>
                </div>
                <div class="joined">
                  <p class="joined-txt">{{"Auction Item.Joined on"|translate}}</p>
                  <span class="joined-time">{{auctionData?.joined_at | dateUTC:'LL'}} {{"Auction Item.at"|translate}}
                    {{auctionData?.joined_at |
                    dateUTC:'h:mm:ss a'}} </span>
                </div>
                <button (click)="onWithdrawAuction()" mat-button class="btn withdraw">
                  {{"Auction Item.withdraw"|translate}}</button>
              </div>
            </ng-container>
            <!-- end  withdraw auction  -->
          </div>
          <!-- end join and withdraw auction  -->


          <!-- when auction  is closed  -->
          <ng-container *ngIf="auctionStatus == 'end'|| auctionData?.is_closed ">
            <!-- when auction wating cron job to end auction -->
            <!-- <ng-container *ngIf="auctionStatus == 'end' && !auctionData?.is_closed && !auctionData.end_at ">
              <p class="text-center mt-3 text-success">{{"Auction Item.AuctionInProgress" | translate}}</p>
            </ng-container> -->
            <!-- when auction wating cron job to end auction -->
            <div class="auction-end">
              <div class="bidder">

                <ng-container *ngIf="winnerAuction  && auctionData?.is_closed ">
                  <img src="assets/images/icons/auction-win.svg">
                  <h2 class="title">{{"Auction Item.The auction has ended"|translate}}</h2>
                  <h4 class="txt">{{"Auction Item.You're the auction winner"|translate}}</h4>
                </ng-container>


                <ng-container *ngIf="!this.winnerAuction">
                  <img src="assets/images/icons/auction-end.svg">
                  <h2 class="title">{{"Auction Item.The auction has ended"|translate}}</h2>
                  <h4 class="txt">{{"Auction Item.You're not the winning bidder"|translate}}</h4>
                </ng-container>


                <div class="last-bid"
                  *ngIf="!  (!getBidders && auctionData?.is_reserve && !auctionData?.is_closed && winnerAuction)">
                  <p class="title">{{"Auction Item.Final Bid"|translate}}</p>
                  <p class="price"> <span>{{"Auction Item.SR"|translate}}</span> {{number | number}}</p>
                </div>

              </div>
            </div>

          </ng-container>

          <!-- end  when auction is closed  -->




        </div>




        <!-- all master actions  -->
        <ng-container *ngIf="master">
          <app-master-auction-config [auctionStatus]="auctionStatus" [startDateTimer]="startDateTimer"
            [endDateTimer]="endDateTimer" [number]="number" [auctionData]="auctionData" [LastBidder]="LastBidder"
            [timeExtended]="timeExtended" [bidders]="bidders" (reloadPage)="reloadPage($event)"
            (AuctionEnded)="OnReload('ongoing',false)"></app-master-auction-config>
        </ng-container>
        <!-- all master actions  -->

        <!-- all auctioneer actions  -->
        <ng-container *ngIf="auctioneer">
          <app-auctioneer-auction-config [auctionStatus]="auctionStatus" [startDateTimer]="startDateTimer"
            [endDateTimer]="endDateTimer" [bidders]="bidders" [number]="number" [auctionData]="auctionData"
            [timeExtended]="timeExtended" [LastBidder]="LastBidder" (reloadPage)="reloadPage($event)"
            (AuctionEnded)="OnReload('ongoing',false)"></app-auctioneer-auction-config>
        </ng-container>
        <!-- all auctioneer actions  -->



        <!-- all owner actions  -->
        <ng-container *ngIf="auctionData?.is_owner && !admin && !auctioneer">
          <app-owner-auction-config [auctionStatus]="auctionStatus" [startDateTimer]="startDateTimer"
            [endDateTimer]="endDateTimer" [number]="number" [auctionData]="auctionData" [LastBidder]="LastBidder"
            [timeExtended]="timeExtended" [bidders]="bidders" (reloadPage)="reloadPage($event)"
            (AuctionEnded)="OnReload('ongoing',false)"></app-owner-auction-config>
        </ng-container>
        <!-- all owner actions  -->

        <!-- all admin actions  -->
        <ng-container *ngIf="admin">
          <app-admin-auction-config [auctionStatus]="auctionStatus" [startDateTimer]="startDateTimer"
            [endDateTimer]="endDateTimer" [number]="number" [auctionData]="auctionData" [LastBidder]="LastBidder"
            [timeExtended]="timeExtended" [bidders]="bidders" (reloadPage)="reloadPage($event)"
            (AuctionEnded)="OnReload('ongoing',false)"></app-admin-auction-config>
        </ng-container>
        <!-- end all admin actions  -->




        <!-- live bidding   -->
        <div *ngIf="(auctionData?.is_joined || (admin || auctioneer || master || auctionData?.is_owner)) "
          class="live-bidding">
          <div class="live" *ngIf="!auctionData.is_closed">
            <!-- <div class="live" *ngIf="auctionStatus != 'end'"> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6">
              <circle id="circle" cx="3" cy="3" r="3" fill="red" />
            </svg>
            {{"Auction Item.Live bidding"|translate}}
          </div>
          <div class="live-end" *ngIf="auctionData.is_closed">
            <!-- <div class="live-end" *ngIf="auctionStatus == 'end'"> -->
            {{"Auction Item.Placed Bids"|translate}} <span class="count">({{(bidders.length)}})</span>
          </div>
          <div class="live-users">
            <div *ngIf="bidders.length == 0" class="nobadding">
              <div class="no-bid text-center">
                <img src="assets/images/icons/no-biding.svg" alt="" srcset="">
                <p class="no-bid-txt">{{"Auction Item.No bidding added yet"|translate}}</p>
              </div>
            </div>

            <ng-container *ngIf="bidders.length > 0 ">

              <div *ngFor="let bidder of bidders" class="user">
                <div class="info">
                  <div class="img">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                      <g id="Avatar" transform="translate(-1130)">
                        <circle id="User-Photo" cx="20" cy="20" r="20" transform="translate(1130)" fill="#ebe9f1" />
                        <path id="user_ic"
                          d="M167.5,282.246a3.372,3.372,0,0,1-2.531-1.014,3.949,3.949,0,0,1,0-5.217,3.665,3.665,0,0,1,5.062,0,3.949,3.949,0,0,1,0,5.217A3.372,3.372,0,0,1,167.5,282.246ZM161.406,290a1.336,1.336,0,0,1-1-.423,1.419,1.419,0,0,1-.41-1.027v-.821a2.717,2.717,0,0,1,.445-1.57,2.883,2.883,0,0,1,1.148-.99,17.274,17.274,0,0,1,3.012-1.087,11.832,11.832,0,0,1,2.895-.362,11.336,11.336,0,0,1,2.883.374,19.572,19.572,0,0,1,3,1.075,2.847,2.847,0,0,1,1.172.99,2.717,2.717,0,0,1,.445,1.57v.821a1.419,1.419,0,0,1-.41,1.027,1.336,1.336,0,0,1-1,.423Z"
                          transform="translate(982.49 -262)" fill="#322075" />
                      </g>
                    </svg>
                  </div>
                  <div class="price-date">
                    <p class="name" *ngIf="bidder?.userID == userInfo?.user?.id">{{"Auction Item.You"|translate}}</p>
                    <p class="name" *ngIf="bidder?.userID != userInfo?.user?.id">
                      {{ bidder?.is_anonymous ? ("Auction Item.Aonymous Bidder"|translate) :(bidder.username |
                      titlecase)}}</p>
                    <p class="date">{{bidder.createdAt | dateUTC:"MMM d, y, h:mm:ss a" }}</p>
                  </div>
                </div>

                <div class="price">
                  <span>{{"Auction Item.SR"|translate}}</span> {{bidder.price}}
                </div>

              </div>

            </ng-container>
          </div>
        </div>
        <!-- end  live bidding   -->

      </div>
    </ng-container>

  </div>
</div>